<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-09 16:11:27
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>App版本管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">App版本列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="版本">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入版本号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                  <!-- <el-button @click="kkk()">http</el-button>
                  <el-button @click="kkk1()">https</el-button> -->
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="APP端" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.useType == 0 ? "用户端" : "保安端" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="versionNo" label="版本" align="center">
          </el-table-column>
          <el-table-column label="分类" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.appType == 0 ? "安卓" : "IOS" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" align="center" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.releaseAt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="强制" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.isForce == 0">否</span>
              <span class="greenColor" v-if="scope.row.isForce == 1">是</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="230">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="down(scope.row)">下载链接</div>
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div class="operateBtn" @click="edit(scope.row)">编辑</div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="600px"
      v-loading="fullscreenLoading"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="App端" prop="useType">
          <el-select
            v-model="ruleForm1.useType"
            placeholder="请选择"
            @change="SelectType"
          >
            <el-option label="用户端" value="0"> </el-option>
            <el-option label="保安端" value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="App分类" prop="type">
          <el-select
            @change="SelectSourse"
            v-model="ruleForm1.type"
            placeholder="请选择"
          >
            <el-option label="安卓" value="0"> </el-option>
            <el-option label="IOS" value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入版本号"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="安卓安装包"
          prop="upload"
          v-if="ruleForm1.type == 0"
        >
          <el-upload
            style="margin-right: auto"
            class="upload-demo"
            :action="uploadUrl"
            :headers="deader"
            :on-success="handSuccess"
            :before-upload="beforeAvatarUpload"
            :limit="1"
            :file-list="fileList"
            accept=".apk"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="IOS下载地址"
          prop="upload"
          v-if="ruleForm1.type == 1"
        >
          <el-input
            disabled
            v-model="ruleForm1.upload"
            placeholder="请输入IOS下载地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本说明" prop="memo">
          <el-input
            type="textarea"
            v-model="ruleForm1.memo"
            placeholder="请输入版本说明"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="发布状态"
          prop="type"
          style="display: flex; align-items: center"
        >
          <el-radio-group v-model="ruleForm1.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="强制更新"
          prop="type"
          style="display: flex; align-items: center"
        >
          <el-radio-group v-model="ruleForm1.upDates">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="APP下载链接"
      :visible.sync="dialogFormVisible1"
      width="600px"
      style="text-align: center"
    >
      <el-input placeholder="请输入内容" v-model="link" :disabled="true">
      </el-input>
      <el-button
        @click="copy(link)"
        style="margin: 20px auto; display: inline-block"
        >复制</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
import { Select } from "element-ui";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      title: "新增版本",
      ruleForm1: {
        type: "",
        status: 1,
        memo: "",
        name: "",
        upload: "",
        useType: "",
        upDates: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        useType: [{ required: true, message: "必选项", trigger: "change" }],
        status: [{ required: true, message: "必选项", trigger: "change" }],
        upDates: [{ required: true, message: "必选项", trigger: "change" }],
        upload: [{ required: true, message: "必选项", trigger: "change" }],
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      options: [{ name: "", id: "" }],
      editId: "",
      fileList: [],
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      link: "",
      fullscreenLoading: false,
      uploadUrl: "",
    };
  },
  mounted() {
    this.getList();
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
  },
  methods: {
    SelectType(val) {
      if (this.ruleForm1.type == "1") {
        let key = "";
        if (val == 0) {
          key = "IOSCustomDownUrl";
        } else {
          key = "IOSBodyguradDownUrl";
        }
        let param = {
          page: 1,
          pageSize: 99999,
          queryParams: [
            {
              name: "prop_name",
              type: "input",
              value: key,
            },
          ],
        };
        this.$axios
          .post(`/admapi/sys/conf/list`, param)
          .then(({ data }) => {
            this.ruleForm1.upload = data.items[0].propValue;
          })
          .catch()
          .finally();
      }
    },
    SelectSourse(val) {
      if (val == "1") {
        let key = "";
        if (this.ruleForm1.useType == 0) {
          key = "IOSCustomDownUrl";
        } else {
          key = "IOSBodyguradDownUrl";
        }
        let param = {
          page: 1,
          pageSize: 99999,
          queryParams: [
            {
              name: "prop_name",
              type: "input",
              value: key,
            },
          ],
        };
        this.$axios
          .post(`/admapi/sys/conf/list`, param)
          .then(({ data }) => {
            this.ruleForm1.upload = data.items[0].propValue;
          })
          .catch()
          .finally();
      }
    },
    kkk() {
      let token =
        "eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE3NTg3NzE4NDUsImp0aSI6IllTckRPVE5KcS05dTAzbk96XzRIWFEiLCJpYXQiOjE3NTYxNzk4NDUsIm5iZiI6MTc1NjE3OTcyNSwic3ViIjoie1widXNlcklkXCI6MTAxLFwidXNlclR5cGVcIjoyfSJ9.vlhwE1IvV9liCazyDELYjj3afuAs1oy_0PjKdwm3me8TusiYqDhHqx1cqd-TerXHOG0iHzuK3E0JJOkSqUQ-pg";
      $.ajax({
        // url:
        //   "http://" +
        //   window.location.hostname +
        //   "/" +
        //   "/mapi/api/security/center/vetern-apply-work",
        url: "http://api-uat.baoanlailou.com/mapi/api/security/center/vetern-apply-work",
        // url:
        //   "http://192.168.6.167:9092/mapi/api/security/center/vetern-apply-work",
        headers: {
          "x-sec-m-token": token,
          "terminal-type": "2",
        },
        data: {
          workType: "2",
        },
        type: "POST", // 或者 'POST', 'PUT', 'DELETE' 等
        dataType: "json", // 期望的返回类型
        success: function (data) {
          alert("提交成功，请等待审核");
        },
        error: function (xhr, status, error) {
          alert("提交失败，请稍后再试");
        },
      });
    },
    kkk1() {
      let token =
        "eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE3NTg3NzE4NDUsImp0aSI6IllTckRPVE5KcS05dTAzbk96XzRIWFEiLCJpYXQiOjE3NTYxNzk4NDUsIm5iZiI6MTc1NjE3OTcyNSwic3ViIjoie1widXNlcklkXCI6MTAxLFwidXNlclR5cGVcIjoyfSJ9.vlhwE1IvV9liCazyDELYjj3afuAs1oy_0PjKdwm3me8TusiYqDhHqx1cqd-TerXHOG0iHzuK3E0JJOkSqUQ-pg";
      $.ajax({
        // url:
        //   "http://" +
        //   window.location.hostname +
        //   "/" +
        //   "/mapi/api/security/center/vetern-apply-work",
        url: "https://api-uat.baoanlailou.com/mapi/api/security/center/vetern-apply-work",
        // url:
        //   "https://192.168.6.167:9092/mapi/api/security/center/vetern-apply-work",
        headers: {
          "x-sec-m-token": token,
          "terminal-type": "2",
        },
        data: {
          workType: "2",
        },
        type: "POST", // 或者 'POST', 'PUT', 'DELETE' 等
        dataType: "json", // 期望的返回类型
        success: function (data) {
          alert("提交成功，请等待审核");
        },
        error: function (xhr, status, error) {
          alert("提交失败，请稍后再试");
        },
      });
    },
    beforeAvatarUpload() {
      this.fullscreenLoading = true;
    },
    copy(msg) {
      const save = function (e) {
        e.clipboardData.setData("text/plain", msg);
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true,
      };
      document.addEventListener("copy", save, once); // 添加一个copy事件
      document.execCommand("copy"); // 执行copy方法
      this.$message({ message: "复制成功", type: "success" });
    },
    down(val) {
      this.link = val.url;
      this.dialogFormVisible1 = true;
    },
    handSuccess(res, fileList) {
      this.ruleForm1.upload = res.data;
      this.fullscreenLoading = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            appType: this.ruleForm1.type,
            versionNo: this.ruleForm1.name,
            status: this.ruleForm1.status,
            memo: this.ruleForm1.memo,
            url: this.ruleForm1.upload.replace(/\s/g, ""),
            useType: this.ruleForm1.useType,
            isForce: this.ruleForm1.upDates * 1,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/appversion/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally((this.dialogFormVisible = false));
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/appversion/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.status = "";
                this.ruleForm1.name = "";
                this.ruleForm1.type = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.upload = "";
                this.ruleForm1.upDates = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/appversion/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    add(formName) {
      this.title = "新增版本";
      this.dialogFormVisible = true;
      this.editId = "";
      this.ruleForm1.type = "";
      this.ruleForm1.status = "";
      this.ruleForm1.memo = "";
      this.ruleForm1.name = "";
      this.ruleForm1.upload = "";
      this.ruleForm1.useType = "";
      this.ruleForm1.upDates = "";
      this.fileList = [];
    },
    edit(val) {
      this.fileList = [];
      this.editId = val.id;
      this.$axios
        .post(`/admapi/appversion/get/${val.id}`)
        .then(({ data }) => {
          this.title = "编辑版本";
          this.dialogFormVisible = true;
          this.ruleForm1.status = data.status;
          this.ruleForm1.name = data.versionNo;
          this.ruleForm1.memo = data.memo;
          this.ruleForm1.upload = data.url;
          this.ruleForm1.upDates = data.isForce.toString();
          let obj = { name: data.url, url: data.url };
          this.fileList.push(obj);
          this.ruleForm1.useType = JSON.stringify(data.useType);
          this.ruleForm1.type = JSON.stringify(data.appType);
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/appversion/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/appversion/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.el-upload-list__item-name {
  max-width: 200px !important;
}
</style>
